import LocationIcon from "@mui/icons-material/LocationPin";
import { Chip,Box, IconButton } from "@mui/material";
import FileIcon from "@mui/icons-material/TextSnippetOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import TelephoneIcon from "@mui/icons-material/Call";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

// import { Statuses } from "../common/constant";

const DynamicTiles = (props) => {

      const getChipStyle = (status) => {
        switch (status) {
          case "Awaiting Review":
            return {
              backgroundColor: "#FFA50033",
              color: "#CB8300",
              height: "20px",
            }; // orange

          case "Scheduled":
            return {
              backgroundColor: "#DBEAFE",
              color: "#081634",
              height: "20px",
            }; // blue
          case "Completed":
            return {
              backgroundColor: "#DCFCE7",
              color: "#1B2C1B",
              height: "20px",
            }; // green
            case "In Progress":
            return {
              backgroundColor: "#FFE0B2",
              color: "#1B2C1B",
              height: "20px",
            }; // green
          default:
            return {
              backgroundColor: "#c3cac7ff",
              color: "#323a32ff",
              height: "20px",
            };
        }
      };
    return (
        <>
            {props.module === "leadDashboard" &&
                <div className="row col-12 col-sm-12 mb-3 resident-card">
                    <div className="d-flex flex-column gap-1 justify-content-start align-items-start p-3">
                        <p className="inspection-tile-header">
                            <input
                                type="checkbox"
                                className="form-check-input text-danger"
                                style={{ marginTop: '0px', borderColor: '#081634' }}
                                checked={props.selectedIds.includes(props?.tableData?.rmsUserInfoId)}
                                onChange={() => props.handleCheckboxChange(props?.tableData?.rmsUserInfoId)}
                            />
                            &nbsp; {props?.tableData?.firstName} {props?.tableData?.lastName}</p>
                        <span className="d-flex flex-row  align-items-center">
                            <LocationIcon fontSize="small" />
                            <p className="dynamic-tile-label">{props?.tableData?.propertyName}, {props?.tableData?.apartmentOrHouseNo}, {props?.tableData?.propertyAddress}, {props?.tableData?.city}, {props?.tableData?.postCode}</p>
                        </span>
                        <div className="d-flex flex-row justify-content-end pt-1 w-100">
                            <Box>

                                <IconButton
                                    tabIndex={0}
                                    title="Generate"

                                >
                                    <FileIcon
                                        sx={{ color: "#081634" }}
                                        fontSize="small"
                                    />
                                </IconButton>
                                <IconButton
                                    tabIndex={0}
                                    title="Send Email"
                                    onClick={() => {
                                        props.setSelectedIds([props?.tableData?.rmsUserInfoId]);
                                        props.setShowEmailConfirmation(true);
                                    }}
                                >
                                    <MailOutlineIcon sx={{ color: "#081634" }} fontSize="small" />
                                </IconButton>
                            </Box>
                        </div>
                    </div>
                </div>}

            {props.module === "adminDashboardProgress" &&
                <div className="row col-12 col-sm-12 mb-3 resident-card">
                    <div className="d-flex flex-column gap-1 justify-content-start align-items-start p-3">

                        {/* Property name and status chip in one line */}
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <p className="inspection-tile-header mb-3">
                                {props?.tableData?.propertyName}
                            </p>
                            <Chip
                                label={props?.tableData?.status}
                                sx={getChipStyle(props?.tableData?.status)}
                            />
                        </div>

                        {/* Inspector info */}
                        <p className="mb-0">
                            <span style={{ fontWeight: '600' }}>Inspector:</span> {props?.tableData?.inspectedBy}
                        </p>

                    </div>
                </div>}
            {props.module === "adminDashboardCompleted" &&
                <div className="row col-12 col-sm-12 mb-3 resident-card">
                    <div className="d-flex flex-column gap-1 justify-content-start align-items-start p-3">

                        {/* Property name and status chip in one line */}
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <p className="inspection-tile-header mb-3">
                                {props?.tableData?.propertyName}
                            </p>
                            <Chip
                                label={props?.tableData?.status}
                                sx={getChipStyle(props?.tableData?.status)}
                            />
                        </div>

                        {/* Inspector info */}
                        <p className="mb-0 text-start">
                            <span style={{ fontWeight: '600' }}>Inspector:</span> {props?.tableData?.inspectedBy}
                        </p>
                        <p className="mb-0">
                            <span style={{ fontWeight: '600' }}>Date:</span> {props?.tableData?.lastInspectionDate != null ? new Date(props?.tableData?.lastInspectionDate).toLocaleDateString("en-GB") : ""}
                        </p>

                    </div>
                </div>}
             {props.module === "memberDashboard" &&
                <div className="row col-12 col-sm-12 mb-3 resident-card">
                    <div className="d-flex flex-column gap-1 justify-content-start align-items-start p-3">
                        <p className="inspection-tile-header">
                                {props?.tableData?.fullName}</p>
                        <span className="d-flex flex-row  align-items-center">
                            <MailOutlineIcon fontSize="small" />
                            <p className="dynamic-tile-label">{props?.tableData?.userEmail}</p>
                        </span>
                         <span className="d-flex flex-row  align-items-center">
                            <TelephoneIcon fontSize="small" />
                            <p className="dynamic-tile-label">{props?.tableData?.phoneNumber}</p>
                        </span>
                         <span className="d-flex flex-row  align-items-center">
                            <LocationIcon fontSize="small" />
                            <p className="dynamic-tile-label">{props?.tableData?.cityName}</p>
                        </span>
                        <hr className="w-100 mb-0"></hr>
                        <div className="row">
                        <p className="dynamic-tile-label mb-0">
                            <div className="d-flex justify-content-between align-items-center w-100">
                            <span style={{ fontWeight: '600' }}>Role: </span>&nbsp;{props?.tableData?.roleName}
                            <span style={{ fontWeight: '600', marginLeft: "20px" }}>User Type: &nbsp;</span> {props?.tableData?.userType}
                            <span className="justify-content-end" style={{ right: '-20px',position: 'relative' }}>
                                <IconButton
                                    tabIndex={0}
                                    title="Edit Member"
                                     onClick={() => {
                                        props.handleEditProperty(props?.tableData?.id);
                                    }}
                                >
                                    <EditIcon
                                        sx={{ color: "#081634" }}
                                        fontSize="small"
                                    />
                                </IconButton>
                                <IconButton
                                    tabIndex={0}
                                    title="Delete Member"
                                    className="p-0"
                                    onClick={() => {
                                        props.setUserToDelete({
                                            userId: props?.tableData?.userId,
                                            propertyId: props?.tableData?.propertyId,
                                            roleId: props?.tableData?.roleId,
                                        });
                                        props.setShowDeleteModal(true);
                                    }}
                                >
                                    <DeleteIcon sx={{ color: "#081634" }} fontSize="small" />
                                </IconButton>
                            </span>
                            </div>

                        </p>
                        </div>

                    </div>
                </div>}
            {props.module === "addPropertyDashboard" &&
           <div className="row col-12 col-sm-12 mb-3 resident-card" >
  {/* Title */}
                    <p className="inspection-tile-header text-start mt-3"> {props?.tableData?.propertyName}</p>

                    <span className="d-flex flex-row  align-items-center">
                        <LocationIcon fontSize="small" />

                        <p className="dynamic-tile-label">
                            {props?.tableData?.propertyLocation}
                            {props?.tableData?.cityName ? `, ${props.tableData.cityName}` : ''}
                            {props?.tableData?.postalCode ? `, ${props.tableData.postalCode}` : ''}
                        </p>

                    </span>

  <hr className="my-2" />

  {/* Floor and Property Type */}
  <div className="d-flex justify-content-between mb-2">
    <div>
      <div className="text-muted small fw-semibold">Total Floor</div>
      <div className="small" >{props?.tableData?.totalNoOfFloors || 0}</div>
    </div>
    <div>
      <div className="text-muted small fw-semibold">Property Type</div>
      <div className="small" style={{ color: 'green' }}>{props?.tableData?.propertyStatus}</div>
    </div>
  </div>

  {/* Inspector and Approver */}
  <div className="d-flex justify-content-between mb-2">
    <div>
      <div className="text-start small fw-semibold">Inspector(s)</div>
      <div className="text-start text-muted small"> {props.tableData.inspectors?.map(i => i.fullName).join(', ')}</div>
    </div>
    <div>
      <div className="text-start small fw-semibold">Approver(s)</div>
      <div className="text-start text-muted small"> {props.tableData.approvers?.map(a => a.fullName).join(', ')}</div>
    </div>
  </div>

  {/* Action Icons */}
  <div className="d-flex justify-content-end mt-2">
    <IconButton title="Edit" onClick={() => { props.handleEditProperty(props?.tableData?.id-1); }}>
      <EditIcon fontSize="small" sx={{ color: '#081634' }} />
    </IconButton>
    <IconButton title="Delete" onClick={() => {
      props.setPropertyToDelete(props?.tableData);
      props.setShowDeleteModal(true);
    }}>
      <DeleteIcon fontSize="small" sx={{ color: '#081634' }} />
    </IconButton>
  </div>
</div>
}
        </>

    );
};

export default DynamicTiles;
